<template>
  <div id="travel">
    <div id="content" class="addedit-travel">
      <Header
        :page="'travel'"
        :title_one="'transfer'"
        :action_one="''"
      ></Header>

      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <div class="title center" v-if="$route.params.type == 1">
            {{ $t("transfer.arrival_title") }}
          </div>
          <div class="title center" v-if="$route.params.type == 3">
            {{ $t("transfer.departure_title") }}
          </div>
          <div class="box">
            <!-- TRANSPORT MODE -->
            <div class="item">
              <label
                >{{ $t("params.transport_mode") }}
                <span class="obligatory">*</span>
              </label>
              <v-select
                attach
                v-bind:class="error.transport_mode ? 'input-error' : ''"
                v-model="travel.transport_mode"
                :multiple="false"
                :items="transport_modes"
                :item-text="'name'"
                item-value="id"
                :disabled="false"
              ></v-select>
            </div>

            <!-- TRANSPORT NUMBER -->
            <div class="item">
              <label
                >{{ $t("params.transport_number") }}
                <span class="obligatory">*</span>
              </label>
              <input
                v-bind:class="error.transport_number ? 'input-error' : ''"
                type="text"
                v-model="travel.transport_number"
                autocomplete="new-text"
              />
            </div>

            <!-- TRANSPORT COMPANY -->
            <div class="item">
              <label
                >{{ $t("params.transport_company") }}
                <span class="obligatory">*</span>
              </label>
              <input
                v-bind:class="error.transport_company ? 'input-error' : ''"
                type="text"
                v-model="travel.transport_company"
                autocomplete="new-text"
              />
            </div>

            <!-- ARRIVAL ORIGIN CITY -->
            <div class="item" v-if="type == 1">
              <label
                >{{ $t("params.origin_city") }}
                <span class="obligatory">*</span>
              </label>
              <input
                v-bind:class="error.origin_city ? 'input-error' : ''"
                type="text"
                v-model="travel.origin.city"
                autocomplete="new-text"
              />
            </div>
            <!-- DEPARTURE DESTINATION CITY -->
            <div class="item" v-else-if="type == 3">
              <label
                >{{ $t("params.destination_city") }}
                <span class="obligatory">*</span>
              </label>
              <input
                v-bind:class="error.destination_city ? 'input-error' : ''"
                type="text"
                v-model="travel.destination.city"
                autocomplete="new-text"
              />
            </div>

            <!-- ARRIVAL DESTINATION LOCATION -->
            <div class="item" v-if="type == 1">
              <label
                >{{ $t("params.destination") }}
                <span class="obligatory">*</span>
              </label>
              <v-select
                attach
                v-bind:class="error.destination_entity_id ? 'input-error' : ''"
                v-model="travel.destination.entity_id"
                :multiple="false"
                :items="Object.values(locations)"
                :item-text="'name'"
                item-value="id"
                :disabled="false"
              ></v-select>
            </div>
            <!-- DEPARTURE ORIGIN LOCATION -->
            <div class="item" v-else-if="type == 3">
              <label
                >{{ $t("params.origin") }} <span class="obligatory">*</span>
              </label>
              <v-select
                attach
                v-bind:class="error.origin_entity_id ? 'input-error' : ''"
                v-model="travel.origin.entity_id"
                :multiple="false"
                :items="Object.values(locations)"
                :item-text="'name'"
                item-value="id"
                :disabled="false"
              ></v-select>
            </div>

            <!-- PAX -->
            <div class="item">
              <label
                >{{ $t("params.n_pax") }} <span class="obligatory">*</span>
              </label>
              <span class="obligatory error" v-if="error.pax">{{
                $t("errors.invalit_number_pax")
              }}</span>
              <input
                v-bind:class="error.pax ? 'input-error' : ''"
                type="number"
                min="0"
                v-model="travel.pax"
                autocomplete="new-text"
              />
            </div>

            <!-- ARRIVAL DESTINATION DAY -->
            <div class="item" v-if="type == 1">
              <label
                >{{ $t("transfer.destination_date") }}
                <span class="obligatory">*</span>
              </label>
              <v-menu
                v-model="dialog_destination_date"
                autocomplete="new-text"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-bind:class="error.destination_date ? 'input-error' : ''"
                    prepend-icon="event"
                    v-model="travel.parsedDestinationDate"
                    @click:prepend="dialog_destination_date = true"
                    @click="dialog_destination_date = true"
                    :placeholder="'DD/MM/YYYY'"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="travel.destination.date"
                  color="blue-grey lighten-2"
                  @input="
                    (dialog_destination_date = false), formatDestinationDate()
                  "
                  :first-day-of-week="firstDayCalendar"
                  :locale="localeCalendar"
                ></v-date-picker>
              </v-menu>
            </div>
            <!-- DEPARTURE DESTINATION DAY -->
            <div class="item" v-else-if="type == 3">
              <label
                >{{ $t("transfer.origin_date") }}
                <span class="obligatory">*</span>
              </label>
              <v-menu
                v-model="dialog_origin_date"
                autocomplete="new-text"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-bind:class="error.origin_date ? 'input-error' : ''"
                    prepend-icon="event"
                    v-model="travel.parsedOriginDate"
                    @click:prepend="dialog_origin_date = true"
                    @click="dialog_origin_date = true"
                    :placeholder="'DD/MM/YYYY'"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="travel.origin.date"
                  color="blue-grey lighten-2"
                  @input="(dialog_origin_date = false), formatOriginDate()"
                  :first-day-of-week="firstDayCalendar"
                  :locale="localeCalendar"
                ></v-date-picker>
              </v-menu>
            </div>

            <!-- ARRIVAL DESTINATION HOUR -->
            <div class="item" v-if="type == 1">
              <label
                >{{ $t("transfer.destination_hour") }}
                <span class="obligatory">*</span>
              </label>
              <v-menu
                ref="menu"
                v-model="dialog_destination_hour"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="destination_time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-bind:class="error.destination_hour ? 'input-error' : ''"
                    prepend-icon="access_time"
                    v-model="travel.destination.hour"
                    @click:prepend="dialog_destination_hour = true"
                    @click="dialog_destination_hour = true"
                    :placeholder="'HH:MM'"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="dialog_destination_hour"
                  format="24hr"
                  color="blue-grey lighten-2"
                  v-model="travel.destination.hour"
                  full-width
                  @click:minute="$refs.menu.save(destination_time)"
                  :rules="[(value) => !!value || $t('rules.required')]"
                ></v-time-picker>
              </v-menu>
            </div>
            <!-- DESTINATION DESTINATION HOUR -->
            <div class="item" v-else-if="type == 3">
              <label
                >{{ $t("transfer.origin_hour") }}
                <span class="obligatory">*</span>
              </label>
              <v-menu
                ref="menu"
                v-model="dialog_origin_hour"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="origin_time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-bind:class="error.origin_hour ? 'input-error' : ''"
                    prepend-icon="access_time"
                    v-model="travel.origin.hour"
                    @click:prepend="dialog_origin_hour = true"
                    @click="dialog_origin_hour = true"
                    :placeholder="'HH:MM'"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="dialog_origin_hour"
                  format="24hr"
                  color="blue-grey lighten-2"
                  v-model="travel.origin.hour"
                  full-width
                  @click:minute="$refs.menu.save(origin_time)"
                  :rules="[(value) => !!value || $t('rules.required')]"
                ></v-time-picker>
              </v-menu>
            </div>

            <!-- CONTACT NAME -->
            <div class="item">
              <label
                >{{ $t("params.contact_name") }}
                <span class="obligatory">*</span></label
              >

              <input
                type="text"
                v-model="travel.contact_name"
                autocomplete="new-text"
                :rules="[(value) => !!value || $t('rules.required')]"
                v-bind:class="error.contact_name ? 'input-error' : ''"
              />
            </div>

            <!-- CONTACT PHONE -->
            <div class="item">
              <label
                >{{ $t("params.contact_phone") }}
                <span class="obligatory">*</span></label
              >

              <input
                type="text"
                v-model="travel.contact_phone"
                autocomplete="new-text"
                :rules="[(value) => !!value || $t('rules.required')]"
                v-bind:class="error.contact_phone ? 'input-error' : ''"
              />
            </div>

            <!-- COMMENTS -->
            <div class="item">
              <label>{{ $t("params.observations") }} </label>
              <input
                type="text"
                v-model="travel.observations"
                autocomplete="new-text"
              />
            </div>

            <ErrorPopup
              @close="closePopup()"
              @input="closePopup()"
              :dialog="dialog"
            ></ErrorPopup>

            <div class="actions">
              <div class="btn" id="cancel" @click="travel_home()">
                {{ $t("cancel") }}
              </div>
              <div class="btn" id="addedit" @click="update()">
                {{ $t("add") }}
              </div>
            </div>
          </div>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Header from "@/components/layout/Header";
import ErrorPopup from "@/components/ui/ErrorPopup.vue";

export default {
  name: "travel_add",
  components: {
    Header,
    ErrorPopup,
  },
  data() {
    return {
      travel: {},
      dialog: false,

      // FORM VARIABLES
      error: {
        transport_mode: false,
        transport_number: false,
        transport_company: false,
        origin_city: false,
        destination_entity_id: false,
        pax: false,
        destination_date: false,
        destination_hour: false,
        origin_date: false,
        origin_hour: false,
        contact_name: false,
        contact_phone: false,
      },
      type: "",

      // FORM TYPE OPTIONS

      // VUETIFY DATEPICKERS & HOURPICKERS
      dialog_origin_date: false,
      dialog_origin_hour: false,
      dialog_destination_date: false,
      dialog_destination_hour: false,
      origin_time: null,
      destination_time: null,
    };
  },
  computed: {
    locations() {
      return this.$store.getters["travel/getLocations"]();
    },

    transport_modes() {
      var oOptions = this.$store.getters.getTransportMode();
      var aResult = [];
      for (var k in oOptions) {
        //   if( oOptions.public == 1 ){
        aResult.push({
          name: i18n.t("transfer.transport_mode." + oOptions[k].name),
          id: oOptions[k].id,
        });
        //   }
      }
      return aResult;
    },

    localeCalendar() {
      var user = this.$store.getters["user/getUser"];
      return user.language;
    },

    firstDayCalendar() {
      var user = this.$store.getters["user/getUser"];
      switch (user.language) {
        case "ca":
        case "es":
          return 1;
        case "en":
          return 7;
      }
      return 1;
    },
  },
  created() {
    this.$overlay.show();

    // If reload, go back
    if (
      this.$route.params.type == undefined &&
      this.$route.params.id == undefined
    ) {
      this.travel_home();
    } else if (this.$route.params.type != undefined) {
      this.type = this.$route.params.type;
    } else if (this.$route.params.id != undefined) {
      var list = this.$store.getters["travel/getList"];
      var findTravel = Object.values(list).find((obj) => {
        return obj.id == this.$route.params.id;
      });
      if (findTravel) {
        this.travel = Object.assign({}, findTravel);
        this.travel.people = [
          { entity_type: 2, entity_id: this.$route.params.team_id },
        ];
        this.type = findTravel.type;
        switch (parseInt(this.type)) {
          case 1:
            this.travel.parsedDestinationDate = moment(
              this.travel.destination.date,
              "DD-MM-YYYY"
            ).format("DD/MM/YYYY");
            this.travel.destination.date = moment(
              this.travel.destination.date,
              "DD-MM-YYYY"
            ).format("YYYY-MM-DD");
            break;
          case 3:
            this.travel.parsedOriginDate = moment(
              this.travel.origin.date,
              "DD-MM-YYYY"
            ).format("DD/MM/YYYY");
            this.travel.origin.date = moment(
              this.travel.origin.date,
              "DD-MM-YYYY"
            ).format("YYYY-MM-DD");
            break;
        }
      } else {
        this.travel_home();
      }
    }

    var self = this;

    var user = this.$store.getters["user/getUser"];
    if (
      user.admin &&
      Object.keys(this.$store.getters["club/getClub"]).length < 1
    ) {
      this.$store
        .dispatch("club/loadClubEvent", {
          club_id: this.user.club_id,
          event_id: this.user.event_id,
        })
        .then(function () {});
    }
    // scroll to top
    window.scroll(0, 0);

    this.$store.dispatch("travel/loadTravelInfo").then(function () {
      if (self.$route.params.type == 1) {
        self.travel = {
          event: user.event_id,
          type: 1,
          travel_number: "",
          transport_number: "",
          transport_company: "",
          origin: {
            entity_type: "0",
            entity_id: "0",
            name: null,
            address: null,
            city: "",
            date: null,
            hour: null,
            coordinates: null,
          },
          destination: {
            entity_type: 11,
            entity_id: "",
            name: null,
            address: null,
            city: null,
            date: "2025-06-13",
            hour: null,
            coordinates: null,
          },
          people: [{ entity_type: 2, entity_id: self.$route.params.team_id }],
          transport_mode: "",
          pax: "0",
          status: "",
        };
      } else if (self.$route.params.type == 3) {
        self.travel = {
          event: user.event_id,
          type: 3,
          travel_number: "",
          transport_number: "",
          transport_company: "",
          origin: {
            entity_type: 11,
            entity_id: "",
            name: null,
            address: null,
            city: null,
            date: "2025-06-15",
            hour: null,
            coordinates: null,
          },
          destination: {
            entity_type: "0",
            entity_id: "0",
            name: null,
            address: null,
            city: "",
            date: null,
            hour: null,
            coordinates: null,
          },
          people: [{ entity_type: 2, entity_id: self.$route.params.team_id }],
          transport_mode: "",
          pax: "0",
          status: "",
        };
      }
    });

    this.$overlay.hide();
  },
  methods: {
    travel_home() {
      this.$router.replace({ name: "travels" });
    },

    formatDestinationDate() {
      this.travel.parsedDestinationDate = moment(
        this.travel.destination.date
      ).format("DD/MM/YYYY");
    },

    formatOriginDate() {
      this.travel.parsedOriginDate = moment(this.travel.origin.date).format(
        "DD/MM/YYYY"
      );
    },

    validate() {
      var validate = true;

      isEmpty(this.travel.transport_mode)
        ? (this.error.transport_mode = true) && (validate = false)
        : (this.error.transport_mode = false);

      isEmpty(this.travel.transport_number)
        ? (this.error.transport_number = true) && (validate = false)
        : (this.error.transport_number = false);

      isEmpty(this.travel.transport_company)
        ? (this.error.transport_company = true) && (validate = false)
        : (this.error.transport_company = false);

      if (this.type == 1) {
        isEmpty(this.travel.origin.city)
          ? (this.error.origin_city = true) && (validate = false)
          : (this.error.origin_city = false);

        isEmpty(this.travel.destination.entity_id)
          ? (this.error.destination_entity_id = true) && (validate = false)
          : (this.error.destination_entity_id = false);
      } else if (this.type == 3) {
        isEmpty(this.travel.destination.city)
          ? (this.error.destination_city = true) && (validate = false)
          : (this.error.destination_city = false);

        isEmpty(this.travel.origin.entity_id)
          ? (this.error.origin_entity_id = true) && (validate = false)
          : (this.error.origin_entity_id = false);
      }

      parseInt(this.travel.pax) < 8
        ? (this.error.pax = true) && (validate = false)
        : (this.error.pax = false);

      if (this.type == 1) {
        isEmpty(this.travel.parsedDestinationDate)
          ? (this.error.destination_date = true) && (validate = false)
          : (this.error.destination_date = false);

        isEmpty(this.travel.destination.hour)
          ? (this.error.destination_hour = true) && (validate = false)
          : (this.error.destination_hour = false);
      } else if (this.type == 3) {
        isEmpty(this.travel.parsedOriginDate)
          ? (this.error.origin_date = true) && (validate = false)
          : (this.error.origin_date = false);

        isEmpty(this.travel.origin.hour)
          ? (this.error.origin_hour = true) && (validate = false)
          : (this.error.origin_hour = false);
      }

      isEmpty(this.travel.contact_name)
        ? (this.error.contact_name = true) && (validate = false)
        : (this.error.contact_name = false);
      isEmpty(this.travel.contact_phone)
        ? (this.error.contact_phone = true) && (validate = false)
        : (this.error.contact_phone = false);

      return validate;
    },

    update() {
      if (this.validate()) {
        if (this.type == 1) {
          this.travel.origin.name = this.travel.origin.city;
        } else if (this.type == 3) {
          this.travel.destination.name = this.travel.destination.city;
        }

        this.travel.parsedPeople = JSON.stringify(this.travel.people);
        this.travel.parsedOrigin = JSON.stringify(this.travel.origin);
        this.travel.parsedDestination = JSON.stringify(this.travel.destination);

        var travel = { ...this.travel };

        var self = this;

        this.$store
          .dispatch("travel/upload", { data: travel })
          .then(function () {
            self.$router.replace({ name: "travels" });
          });
      }
    },
  },
};
</script>
<style lang="scss">
#content.addedit-travel {
  .center {
    margin: 0 auto;
    width: 900px;
    padding: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #aaa;
  }

  .box {
    width: 100% !important;
    max-width: 900px;
    margin: 0 auto;
    margin-top: 25px !important;

    .message.input-error {
      color: $warning-color;
    }

    .upper {
      text-transform: uppercase;
      &::placeholder {
        text-transform: none;
      }
    }

    /* Alergy */
    .v-menu__content {
      margin-top: 43px;
    }

    .item {
      width: 50%;
      margin: 0px 0px 20px 0px;
      padding: 0 15px;
      display: inline-block;

      label {
        font-size: 14px;
        padding: 0;
        margin: 2px 0;
        display: block;
        font-weight: bold;
      }

      .v-radio {
        margin-right: 15px;
      }

      .v-input {
        margin-top: 0;
      }
      .v-input__slot {
        margin-bottom: 0;
      }

      input,
      select,
      .v-autocomplete .v-input__slot {
        width: 100%;
        padding: 10px;
        // margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 16px;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
          opacity: 0.5;
        }
      }

      input:disabled,
      select:disabled,
      .v-input--is-disabled {
        @include opacity(0.3);
      }

      .v-autocomplete {
        margin-top: 0;
        padding-top: 0;

        .v-input__control {
          .v-input__slot {
            margin: 0;
            padding: 4px;

            &:after,
            &:before {
              content: "";
              border: none !important;
            }
          }
          .v-select__slot {
            border: none;

            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 16px;

        &.error {
          display: block;
        }
      }

      .input-error {
        border: 1px solid;
        border-color: $alert-color !important;
        &::placeholder {
          color: $alert-color !important;
          opacity: 0.5;
        }
        .v-input__slot {
          border-color: $alert-color;
        }
      }
    }

    #medicamento,
    #alergy {
      input[type="text"],
      select,
      .v-select {
        display: inline-block;
        width: calc(100% - 40px);
      }

      .checkbox {
        display: inline-block;
        width: 40px;
        height: 40px;
      }
    }
    #alergy {
      .v-select .v-input__slot {
        padding: 6px;
        height: 42px;
      }

      .v-chip .v-chip__content {
        height: 26px;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
    }

    select {
      background-image: url("/img/sort-down.svg");
      background-size: 10px;
      background-position: right 10px center;
      background-repeat: no-repeat;
    }

    select option {
      font-size: 14pt;
    }

    button {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #222;
      color: $secondary-color;

      &:hover {
        background: $main-color;
      }
    }

    .form-subtitle {
      margin-top: 36px;
      background: #eee;
      padding: 7px;

      &:first-of-type {
        margin-top: 12px;
      }
    }
  }

  .v-input {
    padding: 0px;
    height: 42px;
  }

  .v-select__slot {
    border: 1px solid #e3e5f3;
    height: 42px;
    border-radius: 3px;
    padding-left: 10px;

    .v-select__selections {
      input {
        height: 100%;
        border: none !important;
      }
    }
  }

  .v-text-field__slot {
    border: 1px solid #e3e5f3;
    height: 42px;
    border-radius: 3px;
    padding: 0px 10px;

    input {
      height: 100%;
      border: none !important;
      min-height: 42px;
    }
  }

  input {
    min-height: 42px;
    max-height: 42px;
  }

  .v-text-field {
    padding-top: 0px !important;
  }
}

@include media("<=desktop") {
  #content.addedit-person {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;

      .item {
        width: 100%;
        display: block;
      }
    }
  }

  @include media("<=desktop") {
    .actions {
      padding: 25px 0px;

      .btn {
        padding: 0 15px;
      }
    }
  }
}

.actions {
  padding: 25px;
  margin: 0 auto;
  margin-bottom: 25px;
  text-align: center;

  .btn {
    width: calc(50% - 20px);
    margin: 0 10px;
    display: inline-block;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    border-radius: 3px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    background-color: #172654;
    color: #fff;
    height: 40px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    max-width: 300px;

    &#addedit {
    }
    &#cancel {
      border: 1px solid #fc8926;
      background-color: transparent;
      color: #c55c00;
    }
  }
}
</style>

<style lang="scss"></style>
